import React from "react";
import Button from "./elements/button";

interface SiteButtonsProps {
    data: {
        text?: React.ReactNode;
        click?: () => void;
        theme?: "primary" | "secondary" | "danger" | "dark" | "light" | undefined;
        icon?: React.ReactNode;
        type?: "button" | "submit" | "reset";
        form?: string;
        working?: boolean;
        className?: string;
        customstyle?: any;
        disabled?: boolean;
    }[];
}

const SiteButtons: React.FC<SiteButtonsProps> = ({ data }) => {
    return (
        <div className="flex items-center gap-2">
            {data.length > 0 &&
                data.map((item, index) => (
                    <Button
                        type={item.type || "button"}
                        key={index}
                        theme={item.theme || "primary"}
                        onClick={item.click}
                        form={item.form || undefined}
                        working={item.working || false}
                        className={item.className || ""}
                        customstyle={item.customstyle || {}}
                        disabled={item.disabled || (!item.click ? (item.type != "submit" ? true : false) : false)}
                    >
                        {item.icon}
                        {item.text}
                    </Button>
                ))}
        </div>
    );
};
export default SiteButtons;
